import { render, staticRenderFns } from "./ifmInChina.vue?vue&type=template&id=623961b2&scoped=true"
import script from "./ifmInChina.vue?vue&type=script&lang=js"
export * from "./ifmInChina.vue?vue&type=script&lang=js"
import style0 from "./ifmInChina.vue?vue&type=style&index=0&id=623961b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623961b2",
  null
  
)

export default component.exports